import CbboProjectComponent from "./CbboProjectComponent";
import FpoProjectsComponent from "./FpoProjectsComponent";
import { Tabs } from "antd";

const ProjectTabsComponent = () => {
  return (
    <div className="page-content col-12 ">
      {/* <div className=" px-4  border-bottom">
          <h4 className="mb-0 text-orange">Project Categories</h4>
        </div> */}

      <div className="">
        <Tabs
          items={[
            {
              key: "CBBO PROJECTS",
              label: "CBBO PROJECTS",
              children: (
                <div className="">
                  <CbboProjectComponent />
                </div>
              ),
            },
            {
              key: "FPO PROJECTS",
              label: "FPO PROJECTS",
              children: <FpoProjectsComponent />,
            },
          ]}
        />
      </div>
    </div>
  );
};

export default ProjectTabsComponent;
